import {AuctionEvent} from './auction-event';
import {SaleOwner} from './sale-owner.model';

export class SiteHoldingPen {
  auctionEvent: AuctionEvent;
  saleOwners: SaleOwner[];
}
